<template>
  <section>
<div class="row">
    
    <div class="card">
        <div class="card_header">

        </div>
        <div class="card_body">
            <h4>Label | February 25, 2020</h4>
            <h3>Marine animal yoga poses</h3>
            <button @click="$router.push('Blog')">Read more</button>
        </div>
    </div>

    <div class="card">
        <div class="card_header">

        </div>
        <div class="card_body">
            <h4>Label | February 25, 2020</h4>
            <h3>Marine animal yoga poses</h3>
            <button>Read more</button>
        </div>
    </div>

    <div class="card">
        <div class="card_header">

        </div>
        <div class="card_body">
            <h4>Label | February 25, 2020</h4>
            <h3>Marine animal yoga poses</h3>
            <button>Read more</button>
        </div>
    </div>

    <div class="card">
        <div class="card_header">

        </div>
        <div class="card_body">
            <h4>Label | February 25, 2020</h4>
            <h3>Marine animal yoga poses</h3>
            <button>Read more</button>
        </div>
    </div>

    <div class="card">
        <div class="card_header">

        </div>
        <div class="card_body">
            <h4>Label | February 25, 2020</h4>
            <h3>Marine animal yoga poses</h3>
            <button>Read more</button>
        </div>
    </div>

    <div class="card">
        <div class="card_header">

        </div>
        <div class="card_body">
            <h4>Label | February 25, 2020</h4>
            <h3>Marine animal yoga poses</h3>
            <button>Read more</button>
        </div>
    </div>

</div>

  </section>
</template>

<script>
export default {

}
</script>

<style scoped>

    button{
    color: #FF8100;
    background-color: #FFFFF2;
    border: none;
    padding: 15px 30px;
    border-radius: 10px;
    cursor: pointer;
    border: 2px solid #FF8100 ;
    transition: 0.3s ease-in;
}
button:hover{
    color: white;
    background-color: #FF8100;
}

h4{
    color: #44526B;
    font-weight: 500;
    line-height: 200%;
}
h3{
    font-family: Original Surfer;
font-weight: 400;
font-size: 20px;
color: #791E94;
}
 .card_header{
     background-image: url(../../assets/blog.png);
     height: 273px;
     max-width: 100%;
     background-size: cover;
 }
 .card{
     min-height: 426px;
     width: 430px;
     margin-bottom: 50px;
 }
 .card_body{
     display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-around;
    height: 167px;
    
 }
 .row{
     display: flex;
     justify-content: space-between;
     flex-wrap: wrap;
     width: 90%;
     margin: auto;
     padding-top: 70px;
 }
</style>